import { Box, Stack } from '@mui/material'

import { Card, Skeleton } from '@repo/ui'

import { Header } from 'components/navigation'

/**
 * Footprint parity (§19): this mirrors every region the loaded Home has, at the same
 * position and size, so the swap causes zero layout shift.
 *
 * It reuses the page's own `Header` rather than restating its geometry — the title/description
 * spacing is tuned inside that component, so matching it by construction is the only way the
 * skeleton and the page agree after someone edits it.
 *
 * The width cap is part of that parity — the loaded page centres a 720px reading column, so a
 * full-width skeleton would snap inward on load, which is the exact shift §19 exists to stop.
 */
export const HomePageSkeleton = ({ showChecklist = false }: { showChecklist?: boolean }) => (
  <Box sx={{ width: '100%', maxWidth: 720, mx: 'auto' }}>
    <Header title={<Skeleton width={220} height={28} />} description={<Skeleton lines={1} sx={{ maxWidth: 460 }} />} />
    <Stack spacing={4}>
      {showChecklist && (
        <Card spacing={6}>
          <Skeleton width={140} height={20} />
          <Skeleton variant="rounded" height={8} />
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <Stack key={i} direction="row" spacing={3} alignItems="center">
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton sx={{ flexGrow: 1, maxWidth: 320 }} />
            </Stack>
          ))}
        </Card>
      )}
      <Card spacing={6}>
        <Skeleton width={160} height={20} />
        {[0, 1].map((i) => (
          <Stack key={i} direction="row" spacing={3} alignItems="center">
            <Skeleton variant="circular" width={24} height={24} />
            <Stack spacing={1} sx={{ flexGrow: 1 }}>
              <Skeleton sx={{ maxWidth: 220 }} />
              <Skeleton sx={{ maxWidth: 380 }} />
            </Stack>
          </Stack>
        ))}
      </Card>
    </Stack>
  </Box>
)
